import type { SessionSnapshot } from '../session';
import { ChatPanel } from './ChatPanel';
import { DiagnosticsPanel } from './DiagnosticsPanel';
import { SessionHeader } from './SessionHeader';
import { ViewerStage } from './SessionMedia';

export interface ViewerViewProps {
  readonly snapshot: SessionSnapshot;
  readonly fullscreenSupported: boolean;
  readonly onLeave: () => void;
  readonly onRetry: () => void;
}

export function ViewerView({ snapshot, fullscreenSupported, onLeave, onRetry }: ViewerViewProps) {
  return (
    <main class="session-shell session-shell--viewer">
      <SessionHeader
        roomCode={snapshot.roomCode ?? ''}
        recovery={snapshot.recovery}
        expiresAt={snapshot.expiresAt}
        role="viewer"
        onLeave={onLeave}
        onRetry={onRetry}
      />
      <div class="viewer-layout">
        <section class="viewer-main" aria-label="Shared screen">
          <ViewerStage stream={snapshot.remoteStream} fullscreenSupported={fullscreenSupported} />
          <DiagnosticsPanel metrics={snapshot.metrics} iceState={snapshot.iceState} />
        </section>
        <aside class="viewer-sidebar" aria-label="Session chat">
          {snapshot.chat ? <ChatPanel chat={snapshot.chat} /> : null}
        </aside>
      </div>
    </main>
  );
}
